module.exports = __webpack_public_path__ + "static/media/dochilove02.523af00a.jpg";